import { render, staticRenderFns } from "./PushMessageDetail.vue?vue&type=template&id=d717fee4&"
import script from "./PushMessageDetail.vue?vue&type=script&lang=js&"
export * from "./PushMessageDetail.vue?vue&type=script&lang=js&"
import style0 from "./PushMessageDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports